module.exports = __webpack_public_path__ + "static/media/noa_sweatshirt_front.55ae3a6a.png";